import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0;
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 items-center rounded-lg bg-cyan-400/10 border border-cyan-400/20 px-3 py-2.5 text-[13px] font-medium text-cyan-200";
        }
        return "group flex gap-x-3 items-center rounded-lg border border-transparent px-3 py-2.5 text-[13px] font-medium text-slate-400 hover:bg-slate-800 hover:text-slate-100";
    }
}

export default ComponentNavSidebarComponent;